import { render } from "./Artboard_Giveaway.vue?vue&type=template&id=6a7f75a4&scoped=true"
import script from "./Artboard_Giveaway.vue?vue&type=script&lang=js"
export * from "./Artboard_Giveaway.vue?vue&type=script&lang=js"

import "./Artboard_Giveaway.vue?vue&type=style&index=0&id=6a7f75a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a7f75a4"

export default script